// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigation {
  width: 90%; }
  .navigation__item {
    transition: all 0.3s ease;
    color: #ffffff; }
    .navigation__item:hover {
      color: #ff2481; }
  .navigation__tokensInfo p {
    color: white; }
    .navigation__tokensInfo p:hover {
      color: white; }
  .navigation__hamburger {
    display: none; }
  .navigation__wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 20px; }
  .navigation__dropdownWrapper {
    display: inline;
    background-color: transparent; }
    .navigation__dropdownWrapper button {
      background-color: transparent;
      border: none;
      color: #ffffff; }
    .navigation__dropdownWrapper :hover {
      color: #ff2481; }
  .navigation__dropdown {
    transition: all 0.3s ease; }
  .navigation__userInfo {
    color: #ffffff;
    display: flex;
    flex-direction: column;
    padding: 10px;
    justify-content: center;
    text-align: center; }
    .navigation__userInfo span {
      color: #ffffff; }
    .navigation__userInfo a {
      background-color: white; }
    .navigation__userInfo p {
      color: white; }
      .navigation__userInfo p:hover {
        color: white; }
  .navigation__kyc {
    transition: all 0.3s ease;
    border: 2px solid #ff2481;
    border-radius: 6px;
    padding: 10px;
    width: 140px; }
  .navigation__kycNotVerifyed {
    transition: all 0.3s ease;
    border: 2px solid #ff2481;
    border-radius: 6px;
    padding: 10px;
    width: 140px;
    color: #ff2481; }
    .navigation__kycNotVerifyed:hover {
      background-color: #ff2481;
      color: #ffffff; }
  .navigation__buyToken {
    transition: all 0.3s ease;
    background-color: #ff2481;
    color: #ffffff;
    border-radius: 6px;
    padding: 10px;
    width: 140px; }
    .navigation__buyToken:hover {
      background-color: #e02574;
      color: #ffffff; }
    .navigation__buyToken:active {
      background-color: #e02574;
      color: #ffffff; }

.header__dropdown-item .dropdown-item:hover {
  background-color: #ff2481 !important;
  color: #ffffff !important; }

.dropdown-divider {
  margin: 0px !important; }

.dropdown-menu.show {
  border: 2px solid #e02574;
  background-color: rgba(43, 7, 77, 0.85);
  color: #ffffff;
  padding: 0; }

@media (max-width: 997px) {
  .navigation__hamburger {
    display: block;
    z-index: 999;
    position: absolute;
    top: 16px;
    right: 8px;
    width: 50px;
    height: 50px;
    background-color: transparent;
    border: none;
    font-size: 2rem;
    color: #ff2481;
    transition: transform 0.3s ease-in-out; }
  .navigation__close {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer; }
  .navigation__hamburger.active {
    transform: rotate(45deg);
    /* rotate the hamburger menu to form an X */ }
  .navigation__wrapper {
    display: none;
    position: fixed;
    top: 0;
    right: 0;
    height: 100%;
    width: 200px;
    background-color: #340c5a;
    flex-direction: column;
    justify-content: flex-start;
    padding-top: 100px;
    align-items: center;
    gap: 20px;
    z-index: 999; }
  .navigation.showHamburger .navigation__wrapper {
    display: flex; }
  .navigation.showHamburger .navigation__item {
    font-size: 1rem; } }

.showHamburger {
  position: fixed;
  z-index: 999;
  top: 0; }
`, "",{"version":3,"sources":["webpack://./src/components/Navigation/styles.scss","webpack://./src/styles/variables/_variables.scss"],"names":[],"mappings":"AAEA;EACE,UAAU,EAAA;EACV;IACE,yBAAyB;IACzB,cCHqB,EAAA;IDCtB;MAKG,cCY8B,EAAA;EDRjC;IAEG,YAAY,EAAA;IAFf;MAIK,YAAY,EAAA;EAKlB;IACE,aAAa,EAAA;EAGf;IACE,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,SAAS,EAAA;EAGX;IACE,eAAe;IACf,6BAA6B,EAAA;IAF9B;MAKG,6BAA6B;MAC7B,YAAY;MACZ,cCrCmB,EAAA;ID8BtB;MAWG,cCvB8B,EAAA;ED0BlC;IACE,yBAAyB,EAAA;EAE3B;IACE,cChDqB;IDiDrB,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,kBAAkB,EAAA;IANnB;MAQG,cCvDmB,EAAA;ID+CtB;MAYG,uBAAuB,EAAA;IAZ1B;MAeG,YAAY,EAAA;MAff;QAiBK,YAAY,EAAA;EAKlB;IACE,yBAAyB;IACzB,yBCrDgC;IDsDhC,kBAAkB;IAClB,aAAa;IACb,YAAY,EAAA;EAGd;IACE,yBAAyB;IACzB,yBC7DgC;ID8DhC,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,cCjEgC,EAAA;ID2DjC;MAQG,yBCnE8B;MDoE9B,cCtFmB,EAAA;EDyFvB;IACE,yBAAyB;IACzB,yBCzEgC;ID0EhC,cC5FqB;ID6FrB,kBAAkB;IAClB,aAAa;IACb,YAAY,EAAA;IANb;MAQG,yBC9EyB;MD+EzB,cClGmB,EAAA;IDyFtB;MAYG,yBClFyB;MDmFzB,cCtGmB,EAAA;;AD0GzB;EAEI,oCAAwD;EACxD,yBAAkC,EAAA;;AAGtC;EACE,sBAAsB,EAAA;;AAExB;EACE,yBCnG8B;EDoG9B,uCCvH4B;EDwH5B,cCtHuB;EDuHvB,UAAU,EAAA;;AAGZ;EACE;IACE,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,cCpHgC;IDqHhC,sCAAsC,EAAA;EAGxC;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe,EAAA;EAEjB;IACE,wBAAwB;IAAE,2CAAA,EAA4C;EAExE;IACE,aAAa;IACb,eAAe;IACf,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,YAAY;IACZ,yBC5I+B;ID6I/B,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;IACT,YAAY,EAAA;EAGd;IACE,aAAa,EAAA;EAGf;IACE,eAAe,EAAA,EAChB;;AAGH;EACE,eAAe;EACf,YAAY;EACZ,MAAM,EAAA","sourcesContent":["@import \"../../styles/variables/variables\";\n\n.navigation {\n  width: 90%;\n  &__item {\n    transition: all 0.3s ease;\n    color: $tokenWhiteColor;\n\n    &:hover {\n      color: $tokenButtonBackgroundColor;\n    }\n  }\n\n  &__tokensInfo {\n    & p {\n      color: white;\n      &:hover {\n        color: white;\n      }\n    }\n  }\n\n  &__hamburger {\n    display: none;\n  }\n\n  &__wrapper {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 20px;\n  }\n\n  &__dropdownWrapper {\n    display: inline;\n    background-color: transparent;\n\n    & button {\n      background-color: transparent;\n      border: none;\n      color: $tokenWhiteColor;\n    }\n\n    & :hover {\n      color: $tokenButtonBackgroundColor;\n    }\n  }\n  &__dropdown {\n    transition: all 0.3s ease;\n  }\n  &__userInfo {\n    color: $tokenWhiteColor;\n    display: flex;\n    flex-direction: column;\n    padding: 10px;\n    justify-content: center;\n    text-align: center;\n    & span {\n      color: $tokenWhiteColor;\n    }\n\n    & a {\n      background-color: white;\n    }\n    & p {\n      color: white;\n      &:hover {\n        color: white;\n      }\n    }\n  }\n\n  &__kyc {\n    transition: all 0.3s ease;\n    border: 2px solid $tokenButtonBackgroundColor;\n    border-radius: 6px;\n    padding: 10px;\n    width: 140px;\n  }\n\n  &__kycNotVerifyed {\n    transition: all 0.3s ease;\n    border: 2px solid $tokenButtonBackgroundColor;\n    border-radius: 6px;\n    padding: 10px;\n    width: 140px;\n    color: $tokenButtonBackgroundColor;\n    &:hover {\n      background-color: $tokenButtonBackgroundColor;\n      color: $tokenWhiteColor;\n    }\n  }\n  &__buyToken {\n    transition: all 0.3s ease;\n    background-color: $tokenButtonBackgroundColor;\n    color: $tokenWhiteColor;\n    border-radius: 6px;\n    padding: 10px;\n    width: 140px;\n    &:hover {\n      background-color: $tokenButtonHoverColor;\n      color: $tokenWhiteColor;\n    }\n    &:active {\n      background-color: $tokenButtonHoverColor;\n      color: $tokenWhiteColor;\n    }\n  }\n}\n.header__dropdown-item .dropdown-item {\n  &:hover {\n    background-color: $tokenButtonBackgroundColor !important;\n    color: $tokenWhiteColor !important;\n  }\n}\n.dropdown-divider {\n  margin: 0px !important;\n}\n.dropdown-menu.show {\n  border: 2px solid $tokenButtonBorderColor;\n  background-color: $tokenContainerBackgroundColor;\n  color: $tokenWhiteColor;\n  padding: 0;\n}\n\n@media (max-width: 997px) {\n  .navigation__hamburger {\n    display: block;\n    z-index: 999;\n    position: absolute;\n    top: 16px;\n    right: 8px;\n    width: 50px;\n    height: 50px;\n    background-color: transparent;\n    border: none;\n    font-size: 2rem;\n    color: $tokenButtonBackgroundColor;\n    transition: transform 0.3s ease-in-out;\n  }\n\n  .navigation__close {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    cursor: pointer;\n  }\n  .navigation__hamburger.active {\n    transform: rotate(45deg); /* rotate the hamburger menu to form an X */\n  }\n  .navigation__wrapper {\n    display: none;\n    position: fixed; // Add position fixed to the navigation links\n    top: 0;\n    right: 0;\n    height: 100%;\n    width: 200px;\n    background-color: $tokenContainerBorderColor;\n    flex-direction: column;\n    justify-content: flex-start;\n    padding-top: 100px;\n    align-items: center;\n    gap: 20px;\n    z-index: 999; // Set a higher z-index to the navigation links\n  }\n\n  .navigation.showHamburger .navigation__wrapper {\n    display: flex;\n  }\n\n  .navigation.showHamburger .navigation__item {\n    font-size: 1rem;\n  }\n}\n\n.showHamburger {\n  position: fixed;\n  z-index: 999;\n  top: 0;\n}\n","// Main Colors\n$tokenBackgroundColor: #2b074d;\n$tokenContainerBackgroundColor: rgba($tokenBackgroundColor, 0.85);\n$tokenWhiteColor: #ffffff;\n$tokenBlackColor: #000000;\n$tokenPlaceholderColor: #757179;\n\n// Status Colors\n$tokenVerifyStatus: #60ffa8;\n$tokenPendingStatus: #ffdb81;\n$tokenErrorStatus: #ff0000;\n\n// SHADOW\n$tokenContainerShadow: 0 0 14px 0 #ff2481;\n\n// BORDER\n$tokenContainerRadius: 20px;\n$tokenContainerBorderColor: #340c5a;\n\n// BUTTON\n$tokenButtonBorderColor: #e02574;\n$tokenButtonBackgroundColor: #ff2481;\n$tokenButtonHoverColor: #e02574;\n\n// COIN BACKGROUND\n$tokenCoinBackground: #ededed;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
